import React, { useEffect, useRef } from 'react';
import {
  Box,
  Container,
  makeStyles, 
  Typography
} from '@material-ui/core';
import Page from 'src/components/Page';
import AuthCheck from 'src/components/auth-check';
import Results from './Results';
import Toolbar from './Toolbar';

import { useRecoilCallback } from 'recoil';
import { reportReturnTrodeFormAtom } from 'src/app-data/atoms/reports-atom';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "1400px",
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  card: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(3),
    color: theme.palette.text.error
  }
}));

const ReturnTrodeFormView = ({ className }) => {
  const classes = useStyles();
  const componentRef = useRef();

  const resetDataList = useRecoilCallback(({reset}) => async () => {
    reset(reportReturnTrodeFormAtom);
  });

  useEffect(() => {
    resetDataList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthCheck>
    <Page
      className={classes.root}
      title="Return Trode Form"
    >
      <Container maxWidth={false}>
        <Typography color="textPrimary" variant="h4">
          Return Trode Form
        </Typography>

        <Toolbar componentToPrintRef={componentRef} />

        <Box mt={3}>
          <Results componentToPrintRef={componentRef} />
        </Box>
      </Container>
    </Page>
    </AuthCheck>
  );
};

export default ReturnTrodeFormView;